import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OperationType } from 'common/constants/sm-constants';
import { StudentProfileModel } from 'common/models/page-models/studentprofile/formmodel/studentprofile-form.data.model';
import { RouteEnvelope } from 'common/models/utility-models/base-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentProfileWidgetService } from 'common/widget/student-profile-widget.service.ts/student-profile-widget.service';



@Injectable({
    providedIn: 'root'
})
export class StudentProfileResolver extends FormResolverService<StudentProfileModel> {
    constructor(
        protected fs: StudentProfileWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override manageState() {

        if (this.router.getCurrentNavigation().extras.state === undefined) {
            const envelope = new RouteEnvelope();
            envelope.type = OperationType.UPDATE;
            // envelope.transferData = new GridParams();
            return envelope;
        } else {
            return this.router.getCurrentNavigation().extras.state;
        }

    }
 
    override modifyResponseData(dataModel, meta, widget) {
        dataModel['industryType'] = 1;
         dataModel['year'] = 1;
        dataModel['semester'] = 1;
        if (dataModel.summer_vacation_start_date !== '' && dataModel.summer_vacation_end_date !== '' && dataModel.winter_vacation_start_date !== '' && dataModel.winter_vacation_end_date !== '') {
            dataModel.summer_vacation_start_date = this.systemService.dateReturnInNumber(dataModel.summer_vacation_start_date);
            dataModel.summer_vacation_end_date = this.systemService.dateReturnInNumber(dataModel.summer_vacation_end_date);
            dataModel.winter_vacation_start_date = this.systemService.dateReturnInNumber(dataModel.winter_vacation_start_date);
            dataModel.winter_vacation_end_date = this.systemService.dateReturnInNumber(dataModel.winter_vacation_end_date);

        }
        return dataModel;
    }
    
}
